// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"src_bootstrap_js-src_assets_images_loader_gif-node_modules_pure-react-carousel_dist_react-car-afe45b":"6d4837c0","src_assets_style_css":"e99260a8","src_components_UnsubscribeEmail_index_js":"2cd4ffe2"}[chunkId] + ".chunk.css";
};